import { Controller } from "@hotwired/stimulus";

// Makes an entire table row navigate to a URL, so the user can click anywhere
// on the row rather than hunting for the link. Real links, buttons, and form
// controls inside the row keep their own behaviour, and modifier-clicks and
// active text selections are left alone. Rows should retain a visible anchor
// for keyboard and screen-reader users — this only adds pointer navigation.
export default class extends Controller {
  static values = { url: String };

  navigate(event) {
    if (event.target.closest("a, button, input, select, textarea, label")) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (window.getSelection()?.toString()) return;

    Turbo.visit(this.urlValue);
  }
}
